import { useEffect, useState } from "react";

import { QICK_APP_LOGIN_URL } from "@/lib/routes";
import { getCurrentSession, onAuthStateChange } from "@/lib/auth";
import { supabaseConfigError } from "@/lib/supabaseClient";

const ProtectedRoute = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [session, setSession] = useState(null);

    useEffect(() => {
        let isMounted = true;

        getCurrentSession().then(({ data }) => {
            if (!isMounted) return;
            setSession(data.session);
            setIsLoading(false);
        });

        const unsubscribe = onAuthStateChange((_event, nextSession) => {
            setSession(nextSession);
            setIsLoading(false);
        });

        return () => {
            isMounted = false;
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        if (!isLoading && !session && !supabaseConfigError) {
            window.location.replace(QICK_APP_LOGIN_URL);
        }
    }, [isLoading, session]);

    if (supabaseConfigError) {
        return (
            <main className="min-h-screen bg-[#F8FAFC] px-4 py-16 text-slate-900">
                <div className="mx-auto max-w-xl rounded-2xl border border-amber-200 bg-amber-50 p-6 text-amber-950 shadow-sm">
                    <h1 className="text-xl font-extrabold tracking-tight">
                        Supabase configuration required
                    </h1>
                    <p className="mt-3 text-sm leading-relaxed">{supabaseConfigError}</p>
                </div>
            </main>
        );
    }

    if (isLoading) {
        return (
            <main className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 text-slate-700">
                <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-sm font-semibold shadow-sm">
                    Checking session...
                </div>
            </main>
        );
    }

    if (!session) {
        return (
            <main className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 text-slate-700">
                <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-sm font-semibold shadow-sm">
                    Je wordt doorgestuurd naar inloggen...
                </div>
            </main>
        );
    }

    return children;
};

export default ProtectedRoute;
